import { render, staticRenderFns } from "./ProvisionalLoList.vue?vue&type=template&id=1682bdf6&scoped=true"
import script from "./ProvisionalLoList.vue?vue&type=script&lang=js"
export * from "./ProvisionalLoList.vue?vue&type=script&lang=js"
import style0 from "./ProvisionalLoList.vue?vue&type=style&index=0&id=1682bdf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682bdf6",
  null
  
)

export default component.exports